import axiosInstance from '../../../../common/axios.service';
import type {ADD_EMPLOYEE, UPDATE_EMP} from './employees.type';
import type FILTERS from '../../../../common/filters.type';

const employeesList = (values: FILTERS) => {
  return axiosInstance.get('employee/', {params: values}).then((response) => {
    return response;
  });
};

const addEmployee = (values: ADD_EMPLOYEE) => {
  return axiosInstance.post('employee/add/', values).then((response) => {
    return response;
  });
};

const updateEmployee = (values: {payload: UPDATE_EMP; id: number}) => {
  return axiosInstance.put(`employee/${values.id}`, values.payload).then((response) => {
    return response;
  });
};

const employeeService = {
  employeesList,
  addEmployee,
  updateEmployee,
};

export default employeeService;
